import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home-container",
  id: "welcomeMessage"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "welcome-message__messenger-name black__base__color"
}
const _hoisted_4 = {
  key: 1,
  class: "welcome-message__messenger-title black__base__color"
}
const _hoisted_5 = {
  key: 2,
  class: "welcome-message__message-paragraph gray__base__color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (
      $setup.eventData && $setup.eventData.welcomeMessage && $setup.eventData.welcomeMessage != {}
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "app__header__title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("welcomeMessage.aboutEvent")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "app__title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("welcomeMessage.title")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          type: "flex",
          justify: "center",
          gutter: 20,
          class: "mt-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 8,
              lg: 8,
              xl: 8,
              class: "content-align"
            }, {
              default: _withCtx(() => [
                ($setup.eventData.welcomeMessage && $setup.eventData.welcomeMessage.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "welcome-message__image",
                      src: $setup.eventData.welcomeMessage.image
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 16,
              lg: 16,
              xl: 16
            }, {
              default: _withCtx(() => [
                (
            $setup.eventData.welcomeMessage && $setup.eventData.welcomeMessage.messengerName
          )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($setup.eventData.welcomeMessage.messengerName), 1))
                  : _createCommentVNode("", true),
                (
            $setup.eventData.welcomeMessage && $setup.eventData.welcomeMessage.messengerTitle
          )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.eventData.welcomeMessage.messengerTitle), 1))
                  : _createCommentVNode("", true),
                ($setup.eventData.welcomeMessage && $setup.eventData.welcomeMessage.message)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.eventData.welcomeMessage.message), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}